const FilterCheckbox = ({ label, handleCheckbox, value, id }) => {
  return (
    <div className="flex items-center justify-center">
      <label htmlFor={id} className="text-[12px]">
        {label}
      </label>
      <input
        onChange={(e) => handleCheckbox(e.target.checked)}
        checked={value ?? false}
        id={id}
        type="checkbox"
        className="ml-2"
      />
    </div>
  )
}

export default FilterCheckbox
